module.exports = __webpack_public_path__ + "img/7G.049036ef.jpg";